"use client"

import type { PropGetter } from "@/components/ui"
import type { FieldProps } from "@/components/ui/components/field"
import type { UseFileInputProps } from "@/components/ui/components/file-input"
import { useCallback } from "react"
import { ariaAttr } from "@/components/ui"
import { useFileInput } from "@/components/ui/components/file-input"

export interface UseFileButtonProps
  extends UseFileInputProps<"button">,
    FieldProps {}

export const useFileButton = (props: UseFileButtonProps = {}) => {
  const { interactive, clickableProps, getInputProps } =
    useFileInput<"button">(props)

  const getButtonProps: PropGetter<"button"> = useCallback(
    (props) => ({
      ...clickableProps,
      "aria-disabled": ariaAttr(!interactive),
      tabIndex: interactive ? clickableProps.tabIndex : -1,
      ...props,
    }),
    [clickableProps, interactive],
  )

  return {
    clickableProps,
    getButtonProps,
    getInputProps,
  }
}

export type UseFileButtonReturn = ReturnType<typeof useFileButton>
